import React, {Component} from "react";
import PropTypes from "prop-types";

class Field extends Component {
    render() {
        return (
            <section className="field-section">
                <label>{this.props.label || ""}</label>
                <br/>
                <span>{this.props.value || ""}</span>
            </section>
        );
    }
}

Field.propTypes = {
    label: PropTypes.any,
    value: PropTypes.any
};

export default Field
